import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/city/cities.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var getCities = (_0) => __async(void 0, [_0], function* ({ lang, country }) {
  var _a;
  try {
    const locale = getLocaleOnly(lang);
    const data = yield fetchClient({
      url: `/cities/${country}?lang=${locale}`
    });
    if (((_a = data.status) == null ? void 0 : _a.toLowerCase()) !== "success") {
      const msg = Object.values((data == null ? void 0 : data.error) || {})[0] || (data == null ? void 0 : data.error);
      throw new Error(String(msg));
    }
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getCitiesException"
    });
  }
});

export {
  getCities
};
//# sourceMappingURL=chunk-TW72F3BE.mjs.map